// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Package48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Package48: FC<Package48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M22.5 40.3V24.85L9 17.05V32.5l13.5 7.8Zm3 0L39 32.5V17l-13.5 7.85V40.3Zm-3 3.45-15-8.65A2.905 2.905 0 0 1 6.4 34a2.975 2.975 0 0 1-.4-1.5v-17c0-.533.133-1.033.4-1.5a2.905 2.905 0 0 1 1.1-1.1l15-8.65c.467-.267.967-.4 1.5-.4s1.033.133 1.5.4l15 8.65c.467.267.833.633 1.1 1.1.267.467.4.967.4 1.5v17c0 .533-.133 1.033-.4 1.5a2.905 2.905 0 0 1-1.1 1.1l-15 8.65c-.467.267-.967.4-1.5.4a2.974 2.974 0 0 1-1.5-.4Zm9.7-26.25 5.1-2.95L24 6.85 18.9 9.8l13.3 7.7ZM24 22.3l5.2-3.05-13.35-7.7-5.2 3L24 22.3Z" />
        </svg>
    );
};

export default Package48;
